import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';

export const NewsTicker = ({ news }) => {
  if (!news || news.length === 0) return null;

  // Duplicate news for seamless loop
  const tickerItems = [...news, ...news];

  return (
    <div className="bg-[#E53935] text-white py-2 overflow-hidden" data-testid="news-ticker">
      <div className="container mx-auto px-4">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2 flex-shrink-0 bg-white/20 px-3 py-1 rounded-sm">
            <AlertTriangle size={14} className="animate-pulse" />
            <span className="font-['Montserrat'] text-xs font-semibold uppercase tracking-wider">
              Urgente
            </span>
          </div>
          
          <div className="overflow-hidden flex-1">
            <div className="animate-marquee whitespace-nowrap flex gap-12">
              {tickerItems.map((item, index) => (
                <Link
                  key={`${item.id}-${index}`}
                  to={`/noticia/${item.slug}`}
                  className="inline-flex items-center gap-2 hover:underline"
                >
                  <span className="w-1.5 h-1.5 bg-white rounded-full flex-shrink-0" />
                  <span className="font-['Inter'] text-sm">
                    {item.title}
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsTicker;
